import React from 'react';
import Header from '../../Components/Header';
import CabSearch from './CabSearch';

const Cabs = () => (
  <>
  <Header />
   <section className='Cabs_top_banner'>
      <CabSearch />
    </section>
    <section class="footer_top"> 
		<div class="container">
		<div class="_toprflcont mb-8">
			<div class="_hdrtxt">Quick Links </div>
		</div>
     <div class="col-md-12">
        <div class="d-flex-bus">
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Airport.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Airport transfers</h5>
                </a>
            </div>
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Intra.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Intra city</h5>
                </a>
            </div>
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Intercity.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Intercity</h5>
                </a>
            </div>
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Day.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Day Use</h5>
                </a>
            </div>
           
           
           
        </div>
     </div>
           
            
        </div>    
    </section>
  </>
   
);

export default Cabs;
